module.exports = __webpack_public_path__ + "static/media/pin.2ddc7c70.svg";